"use client";
import { useState, useMemo, useEffect } from "react";
import {
  DataGrid,
  GridPaginationModel,
  GridRowId,
  GridRowSelectionModel,
} from "@mui/x-data-grid";
import { UsersToolbar } from "./UserToolbar/UsersToolbar";
import { columns } from "./columns";
import { User } from "@/api/users";

export default function UsersDataGrid({
  roles,
  rows,
}: {
  roles: string[];
  rows: User[];
}) {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });

  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>({
      ids: new Set<GridRowId>([]),
      type: "include",
    });

  const [emailFilter, setEmailFilter] = useState<string>("");

  const filteredRows = useMemo(() => {
    if (!emailFilter.trim()) {
      return rows;
    }
    const filterLower = emailFilter.toLowerCase().trim();
    return rows.filter((user) =>
      user.email.toLowerCase().includes(filterLower),
    );
  }, [rows, emailFilter]);

  // Reset pagination to first page when filter changes
  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [emailFilter]);

  const users: User[] = filteredRows.filter((u) =>
    rowSelectionModel.ids.has(u.id),
  );

  return (
    <DataGrid
      checkboxSelection
      columns={columns}
      onPaginationModelChange={setPaginationModel}
      onRowSelectionModelChange={setRowSelectionModel}
      pageSizeOptions={[5, 10, 25, 50]}
      pagination
      paginationMode="client"
      paginationModel={paginationModel}
      rows={filteredRows}
      rowSelectionModel={rowSelectionModel}
      showToolbar
      // @ts-expect-error 2322
      slots={{ toolbar: UsersToolbar }}
      slotProps={{
        // @ts-expect-error 2353
        toolbar: { roles, users, emailFilter, setEmailFilter },
      }}
    />
  );
}
